<template>
    <div class="classAndGradeConfig clearfix">
        <div class="left">
            <div class="title">部门组织</div>
            <div class="box">
                <div class="tree-box">
                    <el-tree :data="schoolOrganization" :props="deptProps" @node-click="nodeClickHandle" node-key="id" :expand-on-click-node="false" ref="schoolTree" highlight-current :default-expanded-keys="expandNodes" @node-expand="nodeExpandHandle" @node-collapse="nodeCollapseHandle">
                        <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对组织的管理，本页只保留查询和导出 -->
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span v-if="data.type == 1">
                                <span class="label-text">{{node.label}}</span>
                                <template v-if="user.style !== K12TYPE">
                                    <span class="el-icon-plus icon" @click.stop="addCollegeForm(node , data)"></span>
                                </template>
                            </span>
                            <span v-if="data.type == 2">
                                <span class="label-text icon-college">{{node.label}}</span>
                                <template v-if="user.style !== K12TYPE">
                                    <span class="el-icon-plus icon" @click.stop="addDepartmentForm(node, data)"></span>
                                    <span class="el-icon-edit-outline icon" @click.stop="editCollegeForm(node, data)"></span>
                                    <span class="el-icon-delete icon" @click.stop="deleteCollege(node,data)"></span>
                                </template>
                            </span>
                            <span v-if="data.type == 3">
                                <span class="label-text icon-department">{{node.label}}</span>
                                <template v-if="user.style !== K12TYPE">
                                    <span class="el-icon-plus icon" @click.stop="addGradeForm(node, data)"></span>
                                    <span class="el-icon-edit-outline icon" @click.stop="editDepartmentForm(node, data)"></span>
                                    <span class="el-icon-delete icon" @click.stop="deleteDepartment(node, data)"></span>
                                </template>

                            </span>
                            <span v-if="data.type == 4">
                                <span class="label-text icon-grade">{{node.label}}</span>
                                <template v-if="user.style !== K12TYPE">
                                    <span class="el-icon-plus icon" @click.stop="addBatchClassForm(node, data)"></span>
                                    <span class="el-icon-edit-outline icon" @click.stop="editGradeForm(node, data)"></span>
                                    <span class="el-icon-delete icon" @click.stop="deleteGrade(node, data)"></span>
                                </template>

                            </span>
                             <span v-if="data.type == 6">
                                 <span class="label-text icon-college">{{node.label}}</span>
                            </span>
                        </span>
                    </el-tree>
                </div>

            </div>
        </div>
        <div class="right">
            <div class="operation-panel">
                <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对组织的管理，本页只保留查询和导出 -->
                <!-- <span class="btn upgrade" @click="upgrade" v-if="user.style !== K12TYPE">
                    年级升级
                </span> -->
                <span class="btn export" @click="exportClass">
                    导出班级
                </span>
                <!-- <span class="btn import" @click="showImport = true;" v-if="user.style !== K12TYPE">
                    导入班级
                </span> -->
                <el-input v-model="className" class="input" placeholder="请输入班级名称查询">
                    <el-button @click="queryClassByName" slot="append" icon="el-icon-search">查询</el-button>
                </el-input>
            </div>
            <div class="list-wrapper">
                <div v-if="classList && classList.length == 0" style="text-align:center;padding:20px;color:#333">暂无数据</div>
                <ul class="class-list" v-if="classList && classList.length > 0">
                    <li class="class-num">班级数量：
                        <span class="red">{{classList.length}}</span>个</li>
                    <li class="room" v-for="(_class, j) in classList" :key="j">
                        <div class="bg">
                            <span class="num">{{_class.studentNum || 0}}人</span>
                            <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对组织的管理，本页只保留查询和导出 -->
                            <!-- <div class="btn-box" v-if="user.style !== K12TYPE">
                                <div class="edit">
                                    <el-button @click="openClassEditDialog(_class)">编辑</el-button>
                                </div>
                                <div class="delete">
                                    <el-button @click="openClassDeleteDialog(classList, j)">删除</el-button>
                                </div>
                            </div> -->
                        </div>
                        <div class="name">{{_class.className}}</div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 添加和编辑年级 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="editType == 0 ? '添加年级' : '编辑年级'" :visible.sync="showGradeForm" width="500px" height="298px" :before-close="closeDialog" left>
            <el-form ref="gradeForm" label-width="140px" :model="gradeForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span> 带
                    <span class="red">*</span>号的为必填项
                    <span v-show="editType === 0">（默认每个系最后添加的年级为毕业年级）</span>
                </div>
                <el-form-item label="所属学院:" prop="collegeId" :rules="[{required: true,message: '请选择所属学院', trigger: 'blur'}]">
                    <el-select v-model="gradeForm.collegeId" @change="queryDepartCombo(gradeForm.collegeId)" :disabled="editType === 1">
                        <el-option v-for="(department, index) in departmentCombobox" :key="index" :value="department.id" :label="department.departmentName">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择系部:" prop="departId" :rules="[{required: true,message: '请选择系部', trigger: 'blur'}]">
                    <el-select v-model="gradeForm.departId" :disabled="editType === 1">
                        <el-option v-for="(department, index) in deptCombobox" :key="index" :value="department.id" :label="department.departmentName">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年级名称:" prop="gradeName" :rules="[{required: true,message: '年级名称不能为空', trigger: 'blur'},vRules.illegalCharacter]">
                    <el-input v-model="gradeForm.gradeName" v-inputexclude="'\\s+'" placeholder="限20字符数内，不允许输入特殊字符" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item v-if="editType==0" prop="classNum" label="班级数量:" :rules="[vRules.numberPattern]">
                    <el-input v-model="gradeForm.classNum" v-inputexclude="'\\s+'" placeholder="限正整数，不允许输入特殊字符"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">

                <el-button type="primary" @click="comfirmGradeForm">确定</el-button>
                <el-button @click="cancelFormEdit('showGradeForm','gradeForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 添加和编辑系 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="editType == 0 ? '添加系' : '编辑系'" :visible.sync="showDepartmentForm" width="500px" height="298px" :before-close="closeDialog" left>
            <el-form ref="departmentForm" label-width="140px" :model="departmentForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span> 带
                    <span class="red">*</span>号的为必填项
                </div>
                <el-form-item label="所属学院:" prop="schoolNum" :rules="[{required: true,message: '请选择所属学院', trigger: 'blur'}]">
                    <el-select v-model="departmentForm.parentId">
                        <el-option v-for="(department, index) in departmentCombobox" :key="index" :value="department.id" :label="department.departmentName">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="系部名称:" prop="departName" :rules="[
                    { required: true, message: '系部不能为空'},vRules.illegalCharacter]">
                    <el-input placeholder="限20字符数内，不允许输入特殊字符" maxlength="20" v-model="departmentForm.departName" name="departName" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
                <el-form-item v-if="editType==0" label="年级数量:" prop="gradeNum">
                    <el-select v-model="departmentForm.gradeNum">
                        <el-option v-for="(num, index) in [1,2,3,4,5,6,7]" :key="index" :value="num" :label="num">
                            {{num}}
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmDepartmentForm">确定</el-button>
                <el-button @click="cancelFormEdit('showDepartmentForm','departmentForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 添加和编辑学院 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="editType == 0 ? '添加学院' : '编辑学院'" :visible.sync="showCollegeForm" width="570px" height="298px" left>
            <el-form ref="collegeForm" label-width="140px" :model="collegeForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span> 带
                    <span class="red">*</span>号的为必填项
                </div>
                <el-form-item label="所属学校:">
                    <el-input readonly disabled v-model="collegeForm.sName"></el-input>
                </el-form-item>
                <el-form-item label="学院名称:" prop="departName" :rules="[
                    { required: true, message: '学院名称不能为空'},vRules.illegalCharacter]">
                    <el-input v-model="collegeForm.departName" placeholder="限20字符数内，不允许输入特殊字符" maxlength="20" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
                <el-form-item label="所属校区:" prop="schoolNum" :rules="[{required: true,message: '请选择所属校区', trigger: 'blur'}]">
                    <el-select v-model="collegeForm.schoolNum" placeholder="--请选择校区--">
                        <el-option v-for="college in collegeCombobox" :key="college.schoolNum" :label="college.schoolName" :value="college.schoolNum">
                        </el-option>
                    </el-select>
                    <span>* 无法选择校区时，请先到楼栋宿舍配置菜单添加校区</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmCollegeForm">确定</el-button>
                <el-button @click="cancelFormEdit('showCollegeForm','collegeForm')">取消</el-button>
            </span>
        </el-dialog>

        <!-- 编辑班级 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑班级" :visible.sync="showClassForm" width="500px" :before-close="closeDialog" left>
            <el-form ref="classForm" label-width="140px" :model="classForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span>
                    带
                    <span class="red">*</span>号的为必填项
                </div>
                <el-form-item label="所属学院:" prop="collegeId" :rules="[{required: true,message: '请选择所属学院', trigger: 'blur'}]">
                    <el-select v-model="classForm.collegeId" @change="changeDeptCombobox">
                        <el-option v-for="(department, index) in departmentCombobox" :key="index" :value="department.id" :label="department.departmentName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属系部:" prop="departId" :rules="[vRules.requiredSelect]">
                    <el-select v-model="classForm.departId" @change="changeGradeCombobox">
                        <el-option v-for="(department, index) in deptCombobox" :key="index" :value="department.id" :label="department.departmentName">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属年级:" prop="gradeId" :rules="[{required: true,message: '请选择所属年级', trigger: 'blur'}]">
                    <el-select v-model="classForm.gradeId">
                        <el-option v-for="(grade, index) in gradeComobo" :key="index" :value="grade.id" :label="grade.gradeName">

                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级名称:" :rules="[vRules.required,vRules.illegalCharacter]" prop="className">
                    <el-input v-model="classForm.className" placeholder="限20字符数内，不允许输入特殊字符" maxlength="20" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmClassEdit">确定</el-button>
                <el-button @click="cancelFormEdit('showClassForm','classForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 批量添加班级 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="批量添加班级" :visible.sync="showBatchClass" width="570px" height="600px" left :before-close="cancelClassBatchForm">
            <el-form ref="batchClassForm" :model="batchClassForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span> 输入完一个班级名称后按回车键，再输入第二个班级名称，依此类推。
                </div>
                <div class="input-div">
                    <span class="name-box" v-for="(name, index) in addClassList" :key="index">
                        <i class="el-icon-close" @click="deleteSpan(addClassList, index)"></i>
                        {{name}}</span>
                    <input ref="batchInput" v-inputexclude="'\\s+'" @keydown.enter.prevent="pushRoom(addClassList,$event)" class="invisible" v-model="addClassName" maxlength="20" />
                </div>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmClassBatchForm">保存</el-button>
                <el-button @click="cancelClassBatchForm">取消</el-button>

            </span>
        </el-dialog>
        <!-- 升级年级 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="年级升级确认" :visible.sync="showUpGrade" width="520px" height="600px" left>
            <div class="upgrade-div" style="width:450px;height:300px;padding:30px;text-align: center">
                <div style="margin-bottom:20px;">
                    <span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span>
                </div>
                <p class="red text">年级升级前请确保毕业班学生已在本系统办理了退宿！</p>
                <p>升级后基础信息会发生以下变更：</p>
                <p>1、所有班级对应的年级信息升一级；</p>
                <p>2、所有学生对应的年级信息升一级；</p>
                <p>3、毕业年级学生状态变更为“已毕业”，将无法再通过本系统进行管理；</p>
                <p>4、毕业年级学生将自动退宿，所有住宿信息清空，
                    <span class="red">包括学生入住信息及考勤信息，</span>非毕业年级学生住宿信息不受影响。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmUpGrade">确定升级</el-button>
                <el-button @click="showUpGrade = false;">取消</el-button>

            </span>
        </el-dialog>
        <!-- 导入 -->
        <import-upload :showImport.sync="showImport" :importObj="importObj" @importFinishCallback="afterImport()"></import-upload>

    </div>
</template>

<script>

import basetable from '@/mixins/base-table';
import api from '@/api'
import { session } from '@/util'
import vRules from '@/config/validate_rules';
import importUpload from '@/components/importUpload/importUpload.vue';
import { mapState } from 'vuex';


export default {
    components: {
        importUpload
    },
    props: {},
    data () {
        let user = session('user');
        return {
            user,
            vRules,
            isLoading: false,
            editType: 0, // 0新增 1修改
            className: null,
            currentNodeInLeftTree: null, // 当前选中的节点
            // 查询对象:
            queryClassObj: {
                schoolId: user.schoolId,
                gradeId: null,
                departmentId: null,
                collegeId: null,
                schoolNum: null
            },
            // 新增编辑学院
            showCollegeForm: false,
            collegeForm: {
                id: '',
                sName: '',
                departName: '',
                schoolId: user.schoolId,
                userId: user.accountId,
                schoolNum: '',
                treeParentId: user.schoolId,
                treeId: '',
                type: ''
            },
            // 新增编辑系
            showDepartmentForm: false,
            departmentForm: {
                userId: user.accountId,
                parentId: '',
                schoolId: user.schoolId,
                schoolNum: '',
                departName: '',
                gradeNum: '',
                treeParentId: '',
                id: '',
                treeId: '',
                type: ''
            },
            // 新增编辑年级
            showGradeForm: false,
            gradeForm: {
                userId: user.accountId,
                gradeName: '',
                classNum: '',
                departId: '',
                schoolNum: '',
                schoolId: user.schoolId,
                id: '',
                collegeId: '',
                treeId: '',
                type: ''
            },
            // 班级
            showClassForm: false,
            classForm: {
                userId: user.accountId,
                className: '',
                gradeId: '',
                departId: '',
                schoolNum: '',
                collegeId: '',
                id: '',
                type: '',
                treeId: ''
            },
            showBatchClass: false,
            batchClassForm: {
                userId: user.accountId,
                schoolId: user.schoolId,
                classNames: '',
                gradeId: '',
                departmentId: '',
                schoolNum: '',
            },
            addClassList: [],
            addClassName: '',
            // 当前点击的班级
            currentFocusClass: null,
            showRoomEditDialog: false,
            showRoomDeleteDialog: false,
            buildingName: '',
            // 导入
            importObj: {
                title: '导入班级',
                text: '点击下载班级导入模板',
                url: '/static/班级导入模板.xlsx',
                key: 'classFile',
                api: api.systemConfig.importClass
            },
            showImport: false,
            // fileName: '',
            // 最终的树数据
            deptProps: {
                label: 'directorName',
                children: 'nextLevels',
                isLeaf: 'leaf'
            },
            // 年级升级
            showUpGrade: false,
            schoolOrganization: null,
            classList: null,
            oldClassList: null,
            initialClassList: null,
            gradeObj: null,
            // 校区下拉
            collegeCombobox: null,
            // 学院
            departmentCombobox: null,
            // 系
            deptCombobox: null,
            gradeComobo: null,
            currentClickTreeNode: null,
            expandNodes: [],
            lunxunrequesttimer: null


        }
    },
    watch: {
        currentNodeInLeftTree (data, oldVal) {
            if (data) {
                this.queryClassObj = {
                    schoolId: this.user.schoolId,
                    gradeId: null,
                    departmentId: null,
                    collegeId: null
                };
                // 点的是学校
                if (data.type == 1) {
                    this.queryClassObj = {
                        schoolId: this.user.schoolId,
                        gradeId: null,
                        departmentId: null,
                        collegeId: null
                    }
                }
                // 点的是院校
                if (data.type == 2) {
                    this.queryClassObj = {
                        schoolId: this.user.schoolId,
                        gradeId: null,
                        departmentId: null,
                        collegeId: data.relId
                    }
                }
                // 点的是系
                if (data.type == 3) {
                    this.queryClassObj = {
                        schoolId: this.user.schoolId,
                        gradeId: null,
                        departmentId: data.relId,
                        collegeId: null
                    }
                }
                // 点的是年级
                if (data.type == 4) {
                    this.queryClassObj = {
                        schoolId: this.user.schoolId,
                        gradeId: data.relId,
                        departmentId: null,
                        collegeId: null,
                    }
                    if(this.$refs.schoolTree.getNode(data.parentId).data.type == 6) {
                         this.queryClassObj.schoolNum = this.$refs.schoolTree.getNode(data.parentId).data.relId
                    }
                    this.gradeObj = data; // 提供数据给年级升级用
                }
                // 点的是校区
                if (data.type == 6) {
                    this.queryClassObj = {
                        schoolId: this.user.schoolId,
                        schoolNum: data.relId,
                        gradeId: null,
                        departmentId: null,
                        collegeId: null
                    }
                }

            }
        }
    },
    computed: {
        ...mapState([
            'K12TYPE',
            'UNK12TYPE'
        ])
    },
    methods: {
        afterImport () {
            this.queryClassList(this.getQueryClassListParam())
        },
        queryClassList (param) {
            return api.systemConfig.queryUnK12ClassByParams(param).then((res) => {
                if (res.code == 0) {
                    this.classList = res.data;
                    this.oldClassList = res.data;
                    this.initialClassList = res.data;
                }
            })
        },
        queryDepartCombo (id, did) {
            return api.common.querySchoolDepartment({ schoolId: this.user.schoolId, parentId: id }).then((res) => {
                if (res.code == 0) {
                    this.deptCombobox = res.data;
                    this.gradeForm.departId = did || "";
                }
            })
        },
        changeDeptCombobox (value) {
            this.queryDepartCombo(value);
            this.classForm.departId = '';
            this.classForm.gradeId = '';
        },
        changeGradeCombobox (value) {
            this.classForm.gradeId = '';
            this.queryGradeCombobox(value);
        },
        closeDialog (done) {
            this.$refs.collegeForm && this.$refs.collegeForm.resetFields();
            this.$refs.departmentForm && this.$refs.departmentForm.resetFields();
            this.$refs.gradeForm && this.$refs.gradeForm.resetFields();
            this.$refs.classForm && this.$refs.classForm.resetFields();
            done();
        },
        commonDeleteMethod (res, data) {
            if (res.code == 0) {
                this.openSuccessDialog('删除', '删除成功!')
                // 如果删除的是当前高亮的节点
                if (data.id === this.currentNodeInLeftTree.id) {
                    this.currentNodeInLeftTree = null;
                }
                var param = this.getQueryClassListParam();
                this.queryClassList(param);
                this.querySchoolTree();
            } else {
                if (res.code == -2) {
                    this.failDialog('删除失败', '班级已添加学生，无法删除！');
                } else {
                    this.$message(res.message);
                }
            }
        },
        // 新增编辑学院
        comfirmCollegeForm () {
            let successcallback = (res) => {
                if (res.code == 0) {
                    this.querySchoolTree();
                    this.cancelFormEdit('showCollegeForm', 'collegeForm');
                    this.$nextTick(() => {
                        this.openAddComfirmDialog('添加学院', '继续添加学院'
                            , () => {
                                this.addCollegeForm(this.currentClickTreeNode, this.currentClickTreeNode.data)                            })
                    })
                } else {
                    this.$message.error(res.message);
                }
            }
            this.$refs.collegeForm.validate((valid) => {
                if (valid) {
                    if (this.editType == 0) {
                        api.systemConfig.addAcademy(this.collegeForm).then((res) => {
                            successcallback(res);
                        })
                    } else if (this.editType == 1) {
                        api.systemConfig.updateAcademy(this.collegeForm).then((res) => {
                            if (res.code == 0) {
                                this.querySchoolTree();
                                this.cancelFormEdit('showCollegeForm', 'collegeForm');
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    }

                }
            });

        },
        addCollegeForm (node, data) {
            this.currentClickTreeNode = node;
            this.showCollegeForm = true;
            this.editType = 0
            this.collegeForm.sName = data.directorName;
        },
        editCollegeForm (node, data) {
            this.showCollegeForm = true;
            this.editType = 1;
            this.$nextTick(() => {
                this.collegeForm.id = data.relId;
                this.collegeForm.sName = data.parentName;
                this.collegeForm.departName = data.directorName;
                this.collegeForm.schoolNum = data.schoolNum;
                this.collegeForm.type = data.type;
                this.collegeForm.treeId = data.id;
            })

        },
        deleteCollege (node, data) {
            this.openDeleteDialog('确认删除?', '学院', () => {
                this.collegeForm.id = data.relId;
                this.collegeForm.type = data.type;
                this.collegeForm.treeId = data.id;
                api.systemConfig.deleteCollege(this.collegeForm).then((res) => {
                    this.commonDeleteMethod(res, data);
                    // if(res.code == 0) {
                    //     this.openSuccessDialog('删除','删除成功!')
                    //     // 如果删除的是当前高亮的节点
                    //     if(data.id === this.currentNodeInLeftTree.id) {
                    //         this.currentNodeInLeftTree = null;
                    //     }
                    //     var param = this.getQueryClassListParam();
                    //     this.queryClassList(param);
                    //     this.querySchoolTree();
                    // } else {
                    //     if(res.code == -2) {
                    //         this.failDialog('删除失败','班级已添加学生，无法删除！');
                    //     } else {
                    //         this.$message(res.message);
                    //     }
                    // }
                })
            })

        },
        // 新增编辑系
        addDepartmentForm (node, data) {
            this.currentClickTreeNode = node;
            this.querySchoolCollege();
            this.showDepartmentForm = true;
            this.editType = 0;
            this.departmentForm.schoolNum = data.schoolNum;
            this.departmentForm.parentId = data.relId; // 学院
            this.departmentForm.treeParentId = data.id;
        },
        editDepartmentForm (node, data) {
            this.querySchoolCollege();
            this.showDepartmentForm = true;
            this.editType = 1;
            this.$nextTick(() => {
                this.departmentForm.schoolNum = data.schoolNum;
                this.departmentForm.departName = data.directorName;
                this.departmentForm.parentId = data.parentId;
                this.departmentForm.id = data.relId;
                this.departmentForm.type = data.type;
                this.departmentForm.treeId = data.id;
            })

        },
        deleteDepartment (node, data) {
            this.departmentForm.id = data.relId;
            this.departmentForm.type = data.type;
            this.departmentForm.treeId = data.id;
            this.openDeleteDialog('确认删除?', '系', () => {
                api.systemConfig.deleteDepartment(this.departmentForm).then((res) => {
                    this.commonDeleteMethod(res, data);
                    // if(res.code == 0) {
                    //     this.openSuccessDialog('删除','删除成功!')
                    //     this.querySchoolTree();
                    // } else {
                    //     this.$message(res.message);
                    // }
                })
            })


        },
        comfirmDepartmentForm () {
            this.$refs.departmentForm.validate((valid, obj) => {
                if (valid) {
                    if (this.editType == 0) {
                        api.systemConfig.addDepartment(this.departmentForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.querySchoolTree();
                                    this.cancelFormEdit('showDepartmentForm', 'departmentForm');
                                    this.openAddComfirmDialog('添加系', '继续添加系'
                                        , () => {
                                            this.addDepartmentForm(this.currentClickTreeNode, this.currentClickTreeNode.data)                                        }
                                    );
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    } else if (this.editType == 1) {
                        api.systemConfig.updateDepartment(this.departmentForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.querySchoolTree();
                                    this.cancelFormEdit('showDepartmentForm', 'departmentForm');
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    }

                }
            })

        },
        // 新增编辑年级
        addGradeForm (node, data) {
            this.currentClickTreeNode = node;
            this.querySchoolCollege();
            this.queryDepartCombo(data.parentId, data.relId);
            this.showGradeForm = true;
            this.editType = 0;
            this.gradeForm.classNum = '';
            this.gradeForm.collegeId = data.parentId;
            this.gradeForm.schoolNum = data.schoolNum;

        },
        editGradeForm (node, data) {
            this.showGradeForm = true;
            this.editType = 1;
            this.querySchoolCollege();
            this.$nextTick(() => {
                this.gradeForm.collegeId = data.grandId;
                this.queryDepartCombo(data.grandId, data.parentId);
                this.gradeForm.gradeName = data.directorName;
                this.gradeForm.schoolNum = data.schoolNum;
                this.gradeForm.id = data.relId;
                this.gradeForm.type = data.type;
                this.gradeForm.treeId = data.id;
            })

        },
        deleteGrade (node, data) {
            this.gradeForm.id = data.relId;
            this.gradeForm.type = data.type;
            this.gradeForm.treeId = data.id;
            this.openDeleteDialog('确认删除?', '年级', () => {
                api.systemConfig.deleteGrade(this.gradeForm).then((res) => {
                    this.commonDeleteMethod(res, data);
                    // if(res.code == 0) {
                    //     this.openSuccessDialog('删除','删除成功!')
                    //     this.querySchoolTree();
                    // } else if(res.code == -2){
                    //     this.failDialog('删除失败','班级已添加学生，无法删除！');
                    // } else {
                    //     this.$message(res.message);

                    // }
                })
            })
        },
        comfirmGradeForm () {
            let collegeId = this.gradeForm.collegeId;
            let depId = this.gradeForm.departmentId;
            this.$refs.gradeForm.validate((valid, obj) => {
                if (valid) {
                    if (this.editType == 0) {
                        api.systemConfig.addGrade(this.gradeForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.querySchoolTree();
                                    this.cancelFormEdit('showGradeForm', 'gradeForm');
                                    this.openAddComfirmDialog('添加年级', '继续添加年级'
                                        , () => {
                                            this.addGradeForm(this.currentClickTreeNode, this.currentClickTreeNode.data)                                        }
                                    );
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    } else if (this.editType == 1) {
                        api.systemConfig.updateGrade(this.gradeForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.querySchoolTree();
                                    this.cancelFormEdit('showGradeForm', 'gradeForm');
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    }

                }
            })

        },
        // 编辑班级
        openClassEditDialog (_class) {
            this.querySchoolCollege();
            this.queryDepartCombo(_class.collegeId, _class.departmentId);
            this.queryGradeCombobox(_class.departmentId).then(() => {
                this.classForm.gradeId = _class.gradeId;
            });
            this.showClassForm = true;
            this.currentFocusClass = _class;
            // this.classForm.schoolNum = room.;
            this.classForm.collegeId = _class.collegeId;
            this.classForm.className = _class.className;
            this.classForm.departId = _class.departmentId;
            this.classForm.id = _class.id;
            this.classForm.type = _class.type;
            this.classForm.treeId = _class.treeId;
        },
        updateCurrentClassInfo () {
            this.currentFocusClass.collegeId = this.classForm.collegeId;
            this.currentFocusClass.className = this.classForm.className;
            this.currentFocusClass.departmentId = this.classForm.departId;
            this.currentFocusClass.gradeId = this.classForm.gradeId;
            this.currentFocusClass.className = this.classForm.className;
        },
        comfirmClassEdit (_class) {
            this.$refs.classForm.validate((valid, obj) => {
                if (valid) {
                    api.systemConfig.updateClassInfo(this.classForm)
                        .then((res) => {
                            if (res.code == 0) {
                                this.updateCurrentClassInfo();
                                this.cancelFormEdit('showClassForm', 'classForm');

                            } else {
                                this.$message(res.message);
                            }
                        })
                }

            });
        },
        openClassDeleteDialog (classList, j) {
            this.openDeleteDialog('确认删除?', '班级', () => {
                this.classForm.id = classList[j].id;
                this.classForm.type = classList[j].type;
                this.classForm.treeId = classList[j].treeId;
                api.systemConfig.deleteClass(this.classForm).then((res) => {
                    if (res.code == 0) {
                        this.openSuccessDialog('删除', '删除成功!')
                        classList.splice(j, 1);
                    } else if (res.code == -2) {
                        this.failDialog('删除失败', '班级已添加学生，无法删除！');
                    } else {
                        this.$message(res.message);

                    }
                })
            })
        },
        addBatchClassForm (node, data) {
            this.gradeObj = data;
            this.showBatchClass = true;
            this.$nextTick(() => {
                this.$refs.batchInput.focus()
            })
        },
        pushRoom (addClassList, event) {
            if (this.addClassName == '') {
                this.$message('请输入班级名称');
                return;
            }
            let reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]+");
            if (reg.test(this.addClassName)) {
                this.$message('不能输入非法字符!');
                return;
            }
            for (const item of this.addClassList) {
                if (this.addClassName == item) {
                    this.addClassName = ''
                    return;
                }
            }
            let text = this.addClassName;
            this.addClassList.push(text)
            this.addClassName = '';
        },
        deleteSpan (list, index) {
            list.splice(index, 1);
        },
        comfirmClassBatchForm () {
            if (this.addClassList.length == 0) {
                this.$message('至少添加一个班级！');
                return;
            }
            Object.assign(this.batchClassForm, {
                classNames: this.addClassList.join(','),
                gradeId: this.gradeObj.relId,
                departmentId: this.gradeObj.parentId,
                schoolNum: this.gradeObj.schoolNum
            })
            api.systemConfig.addNewClass(this.batchClassForm).then((res) => {
                if (res.code == 0) {
                    this.showBatchClass = false;
                    this.openSuccessDialog('批量添加班级', '添加成功');
                    // let data = this.$refs.schoolTree.getCurrentNode();
                    // if(data) {
                    //     var param = {
                    //         className: this.className,
                    //         schoolId: this.user.schoolId

                    //     };
                    //     if(data.type == 1) {
                    //         param.schoolId = this.user.schoolId;
                    //     }
                    //     if(data.type == 2) {
                    //         param.parentDepartmentId = data.relId;
                    //     }
                    //     if(data.type == 3) {
                    //         param.departmentId = data.relId;
                    //     }
                    //     if(data.type == 4) {
                    //         param.gradeId = data.relId;
                    //     }

                    // }
                    this.queryClassList(this.getQueryClassListParam());
                    this.addClassList = [];
                } else {
                    this.$message(res.message);
                }
            })
        },
        getQueryClassListParam () {
            var param = {
                className: this.className,
                schoolId: this.user.schoolId
            };
            var data = this.currentNodeInLeftTree;
            if (data) {
                // if(data.type == 1) {
                //     param.schoolId = this.user.schoolId;
                // }
                if (data.type == 2) {
                    param.collegeId = data.relId;
                }
                if (data.type == 3) {
                    param.departmentId = data.relId;
                }
                if (data.type == 4) {
                    param.gradeId = data.relId;
                    if(this.$refs.schoolTree.getNode(data.parentId).data.type == 6) {
                        param.schoolNum = this.$refs.schoolTree.getNode(data.parentId).data.relId;
                    }
                }
                if (data.type == 6) {
                    param.schoolNum = data.relId;
                }
            }
            return param;
        },
        cancelClassBatchForm () {
            this.addClassList = [];
            this.addClassName = '';
            this.showBatchClass = false;
        },
        exportClass () {

            let data = this.$refs.schoolTree.getCurrentNode();
            if (data) {
                var param = {
                    className: this.className
                };
                // 点的是院校
                if (data.type == 2) {
                    param.parentDepartmentId = data.relId;
                }
                // 点的是系
                if (data.type == 3) {
                    param.departmentId = data.relId;
                }
                // 点的是年级
                if (data.type == 4) {
                    param.gradeId = data.relId;
                    if(this.$refs.schoolTree.getNode(Node.parentId).data.type == 6) {
                        param.schoolNum = this.$refs.schoolTree.getNode(Node.parentId).data.relId
                    }
                }
                // 校区
                if (data.type == 6) {
                    param.schoolNum = data.relId;
                }
                api.systemConfig.exportClassList(param).then((res) => {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    this.$common.globalExportExl(key, value, '班级导出记录');
                })
            }

        },
        // 年级升级
        upgrade () {
            let date = new Date();
            let month = date.getMonth() + 1;

            if (month > 6 && month < 10) {
                if (month == 7) {
                    let day = date.getDate();
                    if (day < 30) {
                        this.showUpDeniedDialog();
                    } else {
                        this.showUpGrade = true;
                    }
                } else {
                    this.showUpGrade = true;
                }
            } else {
                this.showUpDeniedDialog();
            }
        },
        showUpDeniedDialog () {
            let html = `<div style="width:400px;height:158px;padding:30px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p style="color: red;">操作年级升级时段仅限于每年7月30日至9月30日！</p>
                        </div>`;

            this.$alert(html, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => { })
        },
        comfirmUpGrade () {
            let param = {
                // gradeId: this.gradeObj.relId,
                schoolId: this.user.schoolId,
                // departId: this.gradeObj.parentId,
                userId: this.user.accountId
            }
            api.systemConfig.upGradeLv(param).then((res) => {
                if (res.code == 0) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在年级升级，请稍候...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    let lunxunrequest = () => {
                        return api.systemConfig.checkUpStatus().then((res) => {
                            if (res.code == 0 && res.data) {
                                this.openSuccessDialog('年级升级成功', '年级升级操作成功');
                                this.showUpGrade = false;
                                this.querySchoolTree().then(() => {
                                    this.$refs.schoolTree.setCurrentKey(id);
                                });
                                this.queryClassList({ schoolId: this.user.schoolId });

                            } else {
                                this.lunxunrequesttimer = setTimeout(() => {
                                    lunxunrequest();
                                }, 2000)
                            }
                        })
                    }
                    lunxunrequest();

                } else {
                    $.message(res.message);
                }
            })

        },
        queryClassByName () {
            if (this.className === '') {
                return this.classList = this.oldClassList;
            }
            this.classList = [];
            this.initialClassList.forEach((item) => {
                if (item.className === this.className) {
                    this.classList.push(item);
                }
            })
        },
        cancelFormEdit (dialog, form) {
            this[dialog] = false;
            this.$refs[form].resetFields();
        },
        failDialog (title, msg) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-error" style="color: red;font-size: 50px;"></span> </div>
                            <p>${msg}</p>
                        </div>`;

            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => { })
        },
        openAddComfirmDialog (title, btn, callback) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>添加成功!</p>
                        </div>`;

            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: btn,
                showCancelButton: true,
                cancelButtonText: '关闭'
            }).then(() => {
                callback();
            })
        },
        openSuccessDialog (title, msg) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>${msg}!</p>
                        </div>`;

            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => { })
        },
        openDeleteDialog (title, text, callback) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认删除该${text}吗？</p>
                        </div>`;



            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定删除',
                showCancelButton: true
            }).then(() => {
                callback();
            })
        },
        nodeExpandHandle (data) {
            this.expandNodes.push(data.id);
        },
        nodeCollapseHandle (data) {
            this.expandNodes = this.expandNodes.filter((nodeId) => {
                return nodeId !== data.id;
            })
        },
        nodeClickHandle (data, node, el) {
            this.className = '';
            this.currentNodeInLeftTree = data;
            // var param = {};
            // // 点的是学校
            // if(data.type == 1) {
            //     param.schoolId = this.user.schoolId;
            // }
            // // 点的是院校
            // if(data.type == 2) {
            //     param.collegeId = data.relId;
            // }
            // // 点的是系
            // if(data.type == 3) {
            //     param.departmentId = data.relId;
            // }
            // // 点的是年级
            // if(data.type == 4) {
            //     param.gradeId = data.relId;
            //     this.gradeObj = data; // 提供数据给年级升级用
            // }
            this.$nextTick(() => {
                this.queryClassList(this.queryClassObj);
            })
        },
        querySchoolTree () {
            return api.common.schoolRelationTreeWithoutClass(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.schoolOrganization = res.data;
                    } else {
                        this.$message(res.message);
                    }
                }).then(() => {
                    this.currentNodeInLeftTree = this.currentNodeInLeftTree || this.schoolOrganization[0];
                    if (this.currentNodeInLeftTree) {
                        this.$refs.schoolTree.setCurrentKey(this.currentNodeInLeftTree.id);
                    }
                })

        },
        queryGradeCombobox (departmentId) {
            var param = {
                schoolId: this.user.schoolId,
                departmentId: departmentId
            }
            return api.systemConfig.queryUnK12GreadesByParams(param)
                .then((res) => {
                    if (res.code == 0) {
                        this.gradeComobo = res.data;
                    } else {
                        this.$message(res.message);
                    }
                })

        },
        // 校区
        querySchoolCapmus () {
            return api.systemConfig.querySchoolCapmus(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.collegeCombobox = res.data;
                    }
                })
        },
        // 学院
        querySchoolCollege () {
            return api.systemConfig.querySchoolCollege(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentCombobox = res.data;
                    }
                })
        }
    },
    created () {
        this.queryClassList({ schoolId: this.user.schoolId });
        this.querySchoolCapmus();
    },
    mounted () {
        this.querySchoolTree();

    }
}
</script>
<style lang="scss">
html {
  height: auto;
}

.red {
  color: red;
}

.classAndGradeConfig {
  width: 1200px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  .left {
    width: 300px;
    height: 630px;
    float: left;
    .title {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background-color: #26aef3;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .box {
      height: 590px;
      border: 1px solid #dbdbdb;
      border-top: none;
      overflow: auto;
      padding: 0px 0 0 0;
      .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        background-color: #ecf3fd;
      }
      .tree-box {
        color: #333;
        height: 100%;
        .label-text {
          margin-right: 15px;
          color: #333;
        }
        .icon {
          margin-right: 8px;
          color: #333;
          font-weight: bolder;
        }
      }
    }
  }
  .right {
    width: 860px;
    margin: 0 20px;
    float: left;
    border: 1px solid #dbdbdb;
    .operation-panel {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      background-color: #f0f0f0;
      .input {
        width: 300px;
        float: right;
        margin-top: 5px;
        .el-input__inner {
          border: 1px solid #26aef3;
          border-right: none;
        }
        .el-input-group__append {
          border: 1px solid #26aef3;
          border-left: none;
          background-color: #26aef3;
          color: #fff;
        }
      }
      .btn {
        display: inline-block;
        margin-right: 40px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        &.upgrade {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background-image: url('upgrade.png');
          }
        }
        &.export {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 22px;
            height: 22px;
            background-image: url('export.png');
          }
          &:hover {
            color: #26aef3;
            &:before {
              background-image: url('export-blue.png');
            }
          }
        }
        &.import {
          &:before {
            display: inline-block;
            vertical-align: middle;
            content: '';
            width: 18px;
            height: 18px;
            background-image: url('import.png');
          }
          &:hover {
            color: #26aef3;
            &:before {
              background: url('import-blue.png') -2px -2px no-repeat;
            }
          }
        }
      }
    }
    .list-wrapper {
      padding: 25px 20px;
      .class-list {
        margin-bottom: 20px;
        .class-num {
          padding-bottom: 10px;
          border-bottom: 1px solid #ccc;
          margin-bottom: 20px;
        }
        .room {
          display: inline-block;
          vertical-align: top;
          width: 94px;
          margin-bottom: 28px;
          margin-right: 20px;
          text-align: center;
          &:last-child {
            margin-right: 0;
          }
          .bg {
            position: relative;
            width: 94px;
            height: 94px;
            background: url('class.png') 0 6px no-repeat;
            margin-bottom: 10px;
            &:hover > .btn-box {
              display: block;
            }
            .num {
              position: absolute;
              right: 0;
              top: 0;
              padding: 0 5px;
              background-color: #ffb324;
              font-size: 14px;
              color: #fff;
            }
            .btn-box {
              display: none;
              .edit {
                padding-top: 10px;
                margin-bottom: 10px;
                .el-button {
                  padding: 6px 15px;
                  color: #fff;
                  background: #ffb324;
                  border: 1px solid #ffb324;
                }
              }
              .delete {
                .el-button {
                  padding: 6px 15px;
                  color: #606266;
                  background: #fff;
                }
              }
            }
          }
          .name {
            text-align: center;
          }
        }
      }
    }
  }
  .input-div {
    padding: 10px;
    height: 300px;
    border: 1px solid #ccc;
    overflow: auto;
    .name-box {
      float: left;
      position: relative;
      background-color: #ffb324;
      color: #fff;
      min-width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin: 0 10px 10px 0;
      padding: 0 15px;
      i {
        position: absolute;
        top: 0;
        right: 0;
        transform: scale(0.8);
        cursor: pointer;
      }
    }
    input {
      float: left;
      border: none;
      height: 20px;
      line-height: 20px;
      &:focus {
        outline: none;
      }
    }
  }
  .upgrade-div {
    p {
      text-align: left;
      margin: 10px 0;
    }
    .text {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  .import-dialog {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .rel-import-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      .import-btn {
        position: absolute;
        left: 0;
        width: 140px;
        height: 30px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .down-tepmlate {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('down.png') 0 0 no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }
  .warning-wrapper {
    margin-bottom: 24px;
  }

  .el-form-item__error {
    top: 32px;
  }

  .el-button {
    padding: 6px 15px;
  }

  .el-form-item__label,
  .el-dialog__body {
    color: #333;
  }

  .vl-notify {
    z-index: 2018;
    padding: 0;
  }

  .vl-notify .vl-notify-btns {
    padding: 0;
    text-align: center;
  }

  .warning {
    color: #e6a23c;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/systemConfig/classAndGradeConfig.vue